import { type InputTableActionBarButton, InputTableActionBarV2 } from '@/components/custom/erp';
import type { FormMode } from '@/types/form';

interface InputTableActionBarProps {
  mode: FormMode;
  handleAddRow?: () => void;
  handleDeleteRow?: () => void;
  handleCopyRow?: () => void;
  handlePasteRow?: () => void;
  handleMoveRow?: (direction: 'up' | 'down') => void;
}

const utilityButtons: InputTableActionBarButton[] = [{ type: 'export' }, { type: 'pin' }];

export default function InputTableActionBar(props: InputTableActionBarProps) {
  return <InputTableActionBarV2 {...props} buttons={utilityButtons} />;
}
